import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import useLocalStorage from 'src/shared/hooks/useLocalStorage';
import {
  TableContainer, TableRow, TableCell, Paper, Button, Table, TableBody, Grid, Box, Dialog,
  DialogContent
} from '@mui/material';
import call from 'src/core/services/http';
import { CustomCell, CustomRow } from 'src/shared/TableComponents/TableStyles';
import ListHead from 'src/shared/TableComponents/ListHead';
import { toast } from 'react-toastify';
import SpinnerLoader from "../../../shared/plugin/loader/SpinnerLoader";
import { LoadingButton } from '@mui/lab';
import { fDateTime } from 'src/shared/utils/formatTime';
import Label from 'src/shared/components/label/Label';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
// import ViewBeneficiaries from 'src/packages/ktda-processing/components/viewBeneficiaries';
import TransactionView from "../view/TransactionView"


const TABLE_HEAD = [
  { id: 'description', label: "Payer", alignLeft: true },
  { id: 'total_amount', label: " Total Amount", alignLeft: true },
  { id: 'description', label: "Reference", alignLeft: true },
  { id: 'created_at', label: "Date", alignLeft: true },
  { id: 'distursment_status', label: " Status", alignLeft: true },
  { id: 'action', label: "Action", alignLeft: true },
];



function PaymentHistory() {

  const [shop] = useLocalStorage('shop-details');
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isNotFound, setIsNotFound] = useState(false);
  const [selected, setSelected] = useState([]);
  const [open, setOpen] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [row, setrow] = useState([]);


  const getSingleRecordList = async () => {
    try {
      // alert(item.id)
      const response = await call('get', `/wage-disbursement/instituion-wage-payments-record/?merchant_code=${shop.account_number}&record_status=2`);
      if (response.data.status) {
        setData(response.data);
        console.log(response.data)
        setIsLoading(false);
        if (response.data.result.bulk_uploads_details.length === 0) {
          setIsNotFound(true);
        }
      } else {
        toast.error(response.data.message);
        setIsLoading(false);
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getSingleRecordList();
  }, []);


  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4} lg={4}>
          <Paper variant="outlined" sx={{ py: 2.5, textAlign: 'center', height: 130 }}>
            <Box sx={{ mb: 0.5 }}>
              <ArrowDownwardIcon />
            </Box>

            <Typography variant="h6">Total Records</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {data?.statistics?.total_records} 
            </Typography>

          </Paper>
        </Grid>
        <Grid item xs={12} md={4} lg={4}>

          <Paper variant="outlined" sx={{ py: 2.5, textAlign: 'center', height: 130 }}>
            <Box sx={{ mb: 0.5 }}>
              <SwapVertIcon />
            </Box>
            <Typography variant="h6">Records Awaiting Disbursement</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {data?.statistics?.total_records_awaiting_disbursement} 
            </Typography>

          </Paper>
        </Grid>


        <Grid item xs={12} md={4} lg={4}>

          <Paper variant="outlined" sx={{ py: 2.5, textAlign: 'center', height: 130 }}>
            <Box sx={{ mb: 0.5 }}>
              {/* <Iconify width={30} height={30} /> */}
              <SwapVertIcon />
            </Box>
            <Typography variant="h6">Total Disbursed Records</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {data?.statistics?.total_disbursed_records}
            </Typography>

          </Paper>
        </Grid>

        <Grid item xs={12} md={4} lg={4}>
          <Paper variant="outlined" sx={{ py: 2.5, textAlign: 'center', height: 130 }}>
            <Box sx={{ mb: 0.5 }}>
              {/* <Iconify width={30} height={30} /> */}
              <AttachMoneyIcon />
            </Box>
            <Typography variant="h6">Total Funds Committed</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {data?.statistics?.total_funds_committed}
            </Typography>

          </Paper>
        </Grid>

        <Grid item xs={12} md={4} lg={4}>
          <Paper variant="outlined" sx={{ py: 2.5, textAlign: 'center', height: 130 }}>
            <Box sx={{ mb: 0.5 }}>
              {/* <Iconify width={30} height={30} /> */}
              <AttachMoneyIcon />
            </Box>
            <Typography variant="h6">Total Funds Awaiting Disbursement</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {data?.statistics?.total_funds_awaiting_disbursement}
            </Typography>

          </Paper>
        </Grid>

        
        <Grid item xs={12} md={4} lg={4}>

          <Paper variant="outlined" sx={{ py: 2.5, textAlign: 'center', height: 130 }}>
            <Box sx={{ mb: 0.5 }}>
              {/* <Iconify width={30} height={30} /> */}
              <SwapVertIcon />
            </Box>
            <Typography variant="h6">Total Funds Disbursed</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {data?.statistics?.total_funds_disbursed}
            </Typography>

          </Paper>
        </Grid>

      </Grid>


      <CardContent>
        <TransactionView  />
      </CardContent>
      {/* <Dialog
        fullWidth
        maxWidth='xl'
        open={openView}
        onClose={() => setOpenView(!openView)}
      >
        <DialogContent>
          < ViewUnprocessedRecords item={row} />
        </ DialogContent>
      </ Dialog>

      {isLoading ? (
        <Grid container sx={{ justifyContent: 'center' }}> <SpinnerLoader /></Grid>
      ) : (
        <TableContainer sx={{ overflow: "auto" }}>
          <Table>
            <ListHead
              headLabel={TABLE_HEAD}
              numSelected={Object.keys(selected).length}
            />


            {isNotFound ? (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                    <Paper
                      sx={{
                        textAlign: 'center',
                      }}
                    >
                      <Typography variant="h6" paragraph>
                        Not found
                      </Typography>
                      <Typography variant="body2">
                        No results found for <strong>{shop.account_number}</strong>
                      </Typography>
                    </Paper>
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <TableBody>
                {data?.results?.map((row, index) => {
                  const { id,total_amount,description,institution_saving_account, distursment_status, created_at } = row;
                  const rowNumber = index + 1;

                  return (
                    <CustomRow hover key={id} >
                      <CustomCell >{institution_saving_account.description}</CustomCell>
                      <CustomCell >{total_amount}</CustomCell>
                      <CustomCell >{description}</CustomCell>
                      <CustomCell >{fDateTime(created_at)}</CustomCell>
                      <CustomCell >{distursment_status ? <Label color='info'>Processed</Label> :<Label color='error'>Pending</Label>}</CustomCell>
                      <CustomCell>
                        <Button size='small' variant='outlined' color='secondary' onClick={() => {
                          setrow(row);
                          setOpenView(!openView);
                        }}>
                          View
                        </Button>
                      </CustomCell>
                    </CustomRow>
                  );
                })}
              </TableBody>
            )}
          </Table>
        </TableContainer>
      )} */}
    </>
  );
}

export default PaymentHistory;
